_ = require 'underscore'

isValidDataImage = (url) ->
  _.isString(url) &&
  /^data:image\/(?:png|jpg|jpeg|gif|svg\+xml);base64,[A-Za-z0-9+\/=_-]+$/.test(url)

isValidHttp = (url) ->
  _.isString(url) &&
  /^https?:\/\//.test(url)

isValidUrlForImage = (url) ->
  isValidHttp(url) || isValidDataImage(url)

# when putting image URLs in CSS, we don't want you to be able
# to escape the CSS property with a ' or " and try to set other
# css properties behind our backs
isValidUrlForCSSImage = (url) ->
  isValidUrlForImage(url) && !/['"]/.test(url)

isValidUrlForIframe = (url) ->
  isValidHttp(url)

isValidHeight = (height, maxHeight = Infinity, minHeight = 1) ->
  if !height? || !_.isNumber(height)
    return false
  return height >= minHeight && height <= maxHeight

isValidHexColor = (colorString) ->
  if _.isString(colorString) && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(colorString)
    return true

  return false

# Expected Shape of pluginCover:
#   height: Number
#   url: string
#   edgeColor?: string
#   position?: 'cover' | { padding: boolean, align: 'left'|'right'|'center'}
isValidCover = (pluginCover, cardDetail) ->
  MAX_HEIGHT = 256
  MIN_HEIGHT = if cardDetail then 64 else 8
  if !pluginCover? || !_.isObject(pluginCover)
    return false
  if !isValidUrlForCSSImage(pluginCover.url)
    console?.warn('Invalid URL supplied for card-cover', pluginCover.url)
    return false
  if !isValidHeight(pluginCover.height, MAX_HEIGHT, MIN_HEIGHT)
    console?.warn('Invalid height supplied for card-cover', pluginCover.height)
    return false

  return true

module.exports = {
  isValidCover,
  isValidHeight,
  isValidHexColor,
  isValidUrlForImage,
  isValidUrlForCSSImage,
  isValidUrlForIframe
}



// WEBPACK FOOTER //
// ./app/scripts/lib/plugins/plugin-validators.coffee